"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3704],{

/***/ 75150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ cssVars; }
/* harmony export */ });
var cssVars = {
    topBarHeight: createCssVarHandlers("--top-bar-height")
};
function getRoot() {
    return document.documentElement;
}
function createCssVarHandlers(variableName) {
    return {
        name: variableName,
        getValue: function getValue() {
            return getComputedStyle(getRoot()).getPropertyValue(variableName);
        },
        setValue: function setValue(value) {
            return getRoot().style.setProperty(variableName, value);
        }
    };
}


/***/ }),

/***/ 26540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FL": function() { return /* binding */ createOpportunity; },
/* harmony export */   "So": function() { return /* binding */ authenticateUser; },
/* harmony export */   "wN": function() { return /* binding */ funnelCheckoutMutation; }
/* harmony export */ });
/* unused harmony exports CREATE_OPPORTUNITY, AUTHENTICATE_USER, FUNNEL_CHECKOUT */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26997);
/* harmony import */ var shared_services_opportunityCreationPayload__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45417);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation($attributes: OpportunityAttributes!) {\n    createOpportunity(attributes: $attributes) {\n      success\n      opportunity {\n        id\n        userId\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation AuthenticateUser($email: String!, $password: String!) {\n    authenticateUser(credentials: { email: $email, password: $password }) {\n      authToken\n      userAccount {\n        id\n        email\n        firstName\n        lastName\n        roles\n        owner {\n          ... on Customer {\n            id\n            companyName\n            deliveryAddressStreetAndNumber\n            deliveryAddressPostalCode\n            deliveryAddressCity\n            deliveryAddressCountry\n            salesforceCustomer {\n              billingAddress {\n                street\n                postalCode\n                city\n                country\n              }\n              phoneNumber\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation funnelCheckout($attributes: FunnelCheckoutAttributes!) {\n    funnelCheckout(attributes: $attributes) {\n      opportunity {\n        id\n        userId\n      }\n      customerAccount {\n        uuid\n      }\n      success\n      signInToken\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var CREATE_OPPORTUNITY = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject());
function createOpportunity(payload, _) {
    return _createOpportunity.apply(this, arguments);
}
function _createOpportunity() {
    _createOpportunity = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(payload, param) {
        var client, attributes, ref, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = param.client;
                    attributes = (0,shared_services_opportunityCreationPayload__WEBPACK_IMPORTED_MODULE_1__/* .createOpportunityCreationPayload */ .D)(payload);
                    return [
                        4,
                        client.mutation(CREATE_OPPORTUNITY, {
                            attributes: attributes
                        }).toPromise()
                    ];
                case 1:
                    ref = _state.sent(), result = ref.data;
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _createOpportunity.apply(this, arguments);
}
var AUTHENTICATE_USER = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1());
var authenticateUser = function(email, password, param) {
    var client = param.client;
    return client.mutation(AUTHENTICATE_USER, {
        email: email,
        password: password
    }).toPromise();
};
var FUNNEL_CHECKOUT = (0,urql__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject2());
var funnelCheckoutMutation = function(attributes, param) {
    var client = param.client;
    return client.mutation(FUNNEL_CHECKOUT, {
        attributes: attributes
    }).toPromise();
};


/***/ }),

/***/ 19916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useBreakpointUp; },
/* harmony export */   "a": function() { return /* binding */ useBreakpointDown; }
/* harmony export */ });
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63457);

var useBreakpointDown = function(breakpoint) {
    var isUnderBreakpoint = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down(breakpoint);
    });
    return isUnderBreakpoint;
};
var useBreakpointUp = function(breakpoint) {
    var isOverBreakpoint = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up(breakpoint);
    });
    return isOverBreakpoint;
};


/***/ }),

/***/ 20486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85444);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      pointer-events: none;\n      color: ",
        ";\n      cursor: default;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  text-decoration: none;\n  border-radius: 4px;\n  padding: ",
        ";\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: ",
        ";\n  margin: 0 4px;\n\n  &:hover {\n    background-color: ",
        ";\n    color: black;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function Locale() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("nav", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                className: "sr-only",
                children: "Language switcher"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: router.asPath,
                passHref: true,
                locale: "de",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ToggleButton, {
                    selected: router.locale === "de",
                    children: "DE"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: router.asPath,
                passHref: true,
                locale: "en",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ToggleButton, {
                    selected: router.locale === "en",
                    children: "EN"
                })
            })
        ]
    });
}
var ToggleButton = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].a */ .ZP.a(_templateObject1(), function(props) {
    return props.theme.spacing(1, 1);
}, function(props) {
    return props.theme.palette.grey[600];
}, function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.selected && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject(), function(props) {
        return props.theme.palette.common.white;
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (Locale);


/***/ }),

/***/ 44955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ identifyUser; },
/* harmony export */   "De": function() { return /* binding */ trackConversion; },
/* harmony export */   "zz": function() { return /* binding */ pushDataLayer; }
/* harmony export */ });
/* unused harmony export getIdentity */
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55877);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(uuid__WEBPACK_IMPORTED_MODULE_0__);


var STORAGE_KEY = "_heycater_identity";
var USER_IDENTITY_VALUE = (0,uuid__WEBPACK_IMPORTED_MODULE_0__.v4)();
function getIdentity() {
    if (!doesLocalStorageExist()) {
        return USER_IDENTITY_VALUE;
    }
    if (!localStorage.getItem(STORAGE_KEY)) {
        localStorage.setItem(STORAGE_KEY, USER_IDENTITY_VALUE);
    }
    return localStorage.getItem(STORAGE_KEY);
}
function identifyUser(identity) {
    window.gtag && window.gtag("config", "G-856Y5131LS", {
        user_id: identity
    });
    window.analytics && window.analytics.identify(identity);
}
function pushDataLayer(uuid) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        userId: uuid
    });
}
function trackConversion() {
    var properties = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    window.analytics && window.analytics.track("conversion", properties);
}


/***/ }),

/***/ 10045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAuthentication; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92432);
/* harmony import */ var lib_graphql_mutations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26540);
/* harmony import */ var qualification_hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(866);






function useAuthentication() {
    var ref = (0,qualification_hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), refetchCurrentUser = ref.refetch;
    var client = (0,urql__WEBPACK_IMPORTED_MODULE_3__/* .useClient */ .m8)();
    var login = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(variables) {
            var ref, _data, _authenticateUser, authToken, userAccount, onSubmitResponse;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,lib_graphql_mutations__WEBPACK_IMPORTED_MODULE_1__/* .authenticateUser */ .So)(variables.email, variables.password, {
                                client: client
                            })
                        ];
                    case 1:
                        ref = _state.sent(), _data = ref.data, _authenticateUser = _data.authenticateUser, authToken = _authenticateUser.authToken, userAccount = _authenticateUser.userAccount;
                        onSubmitResponse = function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                                    localStorage.setItem("token", authToken);
                                    refetchCurrentUser({
                                        requestPolicy: "network-only"
                                    });
                                    return [
                                        2,
                                        {
                                            userAccount: userAccount
                                        }
                                    ];
                                });
                            });
                            return function onSubmitResponse() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        return [
                            4,
                            onSubmitResponse()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                authToken: authToken,
                                userAccount: userAccount
                            }
                        ];
                }
            });
        });
        return function(variables) {
            return _ref.apply(this, arguments);
        };
    }(), [
        refetchCurrentUser
    ]);
    var logout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        localStorage.removeItem("token");
        refetchCurrentUser({
            requestPolicy: "network-only"
        });
    }, []);
    return {
        login: login,
        logout: logout
    };
}


/***/ }),

/***/ 93054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_Navigation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Hidden/Hidden.js + 3 modules
var Hidden = __webpack_require__(53450);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/AccountCircle.js
var AccountCircle = __webpack_require__(19814);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardArrowDown.js
var KeyboardArrowDown = __webpack_require__(51115);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardArrowUp.js
var KeyboardArrowUp = __webpack_require__(25281);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
// EXTERNAL MODULE: ./src/lib/cssVariables.js
var cssVariables = __webpack_require__(75150);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
// EXTERNAL MODULE: ./src/qualification/hooks/useCurrentUser.ts + 1 modules
var useCurrentUser = __webpack_require__(866);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/shared/helpers/urls.ts
var urls = __webpack_require__(6880);
// EXTERNAL MODULE: ./src/shared/hooks/useAuthentication.ts
var useAuthentication = __webpack_require__(10045);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
;// CONCATENATED MODULE: ./src/shared/hooks/useElementSize.js


function useElementSize() {
    var debounce = function debounce(fn, delay) {
        var timeoutId;
        return function debouncedFn() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _this = this;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function() {
                return fn.apply(_this, args);
            }, delay);
        };
    };
    var ref = (0,react.useState)({
        width: 0,
        height: 0
    }), size = ref[0], setSize = ref[1];
    var prevSizeRef = (0,react.useRef)({
        width: 0,
        height: 0
    });
    var ref1 = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var element = ref1.current;
        var handleResize = debounce(function(entries) {
            var _contentRect = entries[0].contentRect, newWidth = _contentRect.width, newHeight = _contentRect.height;
            if (prevSizeRef.current.width !== newWidth || prevSizeRef.current.height !== newHeight) {
                prevSizeRef.current = {
                    width: newWidth,
                    height: newHeight
                };
                setSize({
                    width: newWidth,
                    height: newHeight
                });
            }
        }, 100);
        var resizeObserver = new ResizeObserver(handleResize);
        if (element) {
            resizeObserver.observe(element);
        }
        return function() {
            if (element) {
                resizeObserver.unobserve(element);
            }
        };
    }, [
        ref1
    ]);
    return (0,_object_spread/* default */.Z)({
        ref: ref1
    }, size);
}

;// CONCATENATED MODULE: ./src/shared/layouts/NewPill.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 4px 8px;\n  border-radius: 100px;\n  background: #7d8f5c;\n  color: #fff;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var NewPill = function() {
    var t = (0,useTranslation/* useTranslation */.$)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
            position: "relative",
            top: "1px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                fontSize: 10,
                lineHeight: 1,
                fontWeight: 700,
                children: t("generic.new").toUpperCase()
            })
        })
    });
};
var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
/* harmony default export */ var layouts_NewPill = (NewPill);

// EXTERNAL MODULE: ./src/shared/services/trustedShops/handleRatings.ts
var handleRatings = __webpack_require__(95046);
// EXTERNAL MODULE: ./src/shared/svg/Logo.js
var Logo = __webpack_require__(37582);
;// CONCATENATED MODULE: ./src/shared/svg/MenuIcon.js


function MenuIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "26",
        height: "16",
        viewBox: "0 0 26 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "26",
                height: "2",
                rx: "1",
                fill: "#374C19"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "11",
                y: "7",
                width: "15",
                height: "2",
                rx: "1",
                fill: "#374C19"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                y: "14",
                width: "26",
                height: "2",
                rx: "1",
                fill: "#374C19"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/shared/svg/TrustedShopsLogo.tsx
var TrustedShopsLogo = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/shared/svg/TrustedShopsStars.js
var TrustedShopsStars = __webpack_require__(95359);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/helpers.ts
var helpers = __webpack_require__(10904);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/shared/layouts/Navigation.tsx

function Navigation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  text-decoration: none;\n"
    ]);
    Navigation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px;\n  background-color: ",
        ";\n  color: white;\n  font-size: 12px;\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  text-decoration: inherit;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  background: white;\n  z-index: ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 150px;\n  height: ",
        ";\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n\n  & > span {\n    display: inline-flex;\n    margin-left: 10px;\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-grow: 1;\n  margin-left: 2em;\n\n  ",
        " {\n    margin-left: 0;\n    position: fixed;\n    top: var(",
        ");\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: ",
        ";\n    background: white;\n    overflow-y: auto;\n    display: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding-left: 0;\n\n  ",
        " {\n    display: block;\n    flex-grow: unset;\n    width: 100%;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  min-height: ",
        ";\n  display: flex;\n  align-items: center;\n\n  ",
        " {\n    display: block;\n    min-height: auto;\n  }\n\n  ",
        " {\n    &[data-dropdown='true']:hover > .navigation-dropdown {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    border-bottom: none;\n    margin: ",
        ";\n\n    > a {\n      font-weight: ",
        ";\n      display: ",
        ";\n      justify-content: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  min-height: ",
        ";\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 16px;\n  border: none;\n  background: inherit;\n  display: flex;\n  width: 100%;\n  margin-right: 0;\n  flex-grow: 1;\n  text-decoration: none;\n  font-size: 14px;\n  font-family: inherit;\n  cursor: pointer;\n  font-weight: 500;\n  align-items: center;\n  a {\n    text-decoration: none;\n    color: inherit;\n  }\n\n  &,\n  &:hover {\n    color: ",
        ";\n  }\n\n  ",
        " {\n    font-weight: 700;\n    justify-content: space-between;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: white;\n  min-height: 30px;\n  overflow: hidden;\n  position: absolute;\n  top: ",
        ";\n  z-index: ",
        ";\n  padding: ",
        "px;\n  left: 14px;\n  min-width: 250px;\n  border-left: 1px solid ",
        ";\n  border-right: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  display: none;\n\n  ",
        " {\n    position: static;\n    background: transparent;\n    padding: 0 30px;\n    left: 0;\n    width: 100%;\n    border: none;\n    border-top: 1px solid ",
        ";\n    border-bottom: 1px solid ",
        ";\n    background: ",
        ";\n    display: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding: 10px 0;\n  border: none;\n  background: inherit;\n  cursor: pointer;\n  color: ",
        ";\n  text-decoration: none;\n  font-size: 14px;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  ",
        " {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0px 20px;\n  margin-left: auto;\n  left: 16px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 10px;\n  justify-content: space-between;\n\n  ",
        " {\n    justify-content: center;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 6px;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  color: white;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 17px;\n  width: 100%;\n  min-width: 70px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 12px;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}



























function Navigation(param) {
    var ratings = param.ratings, hideNavigationLinks = param.hideNavigationLinks, renderCTA = param.renderCTA, mainLinks = param.mainLinks;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var ref = (0,react.useState)(null), visibleDropdown = ref[0], setVisibleDropdown = ref[1];
    var ref1 = (0,react.useState)(false), mobileMenuOpen = ref1[0], setMobileMenuOpen = ref1[1];
    var mobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    var onToggleDropdownVisibility = react.useCallback(function(name) {
        if (!mobile) return;
        if (name === visibleDropdown) {
            setVisibleDropdown(null);
        } else {
            setVisibleDropdown(name);
        }
    }, [
        visibleDropdown,
        mobile
    ]);
    var ref2 = useElementSize(), navRef = ref2.ref, navHeight = ref2.height;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        cssVariables/* cssVars.topBarHeight.setValue */.D.topBarHeight.setValue("".concat(Math.floor(navHeight), "px"));
        return function() {
            return cssVariables/* cssVars.topBarHeight.setValue */.D.topBarHeight.setValue(0);
        };
    }, [
        navHeight
    ]);
    var ref3 = (0,useCurrentUser/* default */.Z)(), currentUserAccount = ref3.currentUserAccount, loading = ref3.loading;
    var logout = (0,useAuthentication/* default */.Z)().logout;
    var isLoggedIn = !loading && currentUserAccount;
    var showSignupButton = !isLoggedIn && !hideNavigationLinks;
    var userMenuLinks = function() {
        var ref, ref1;
        var menuList = [];
        if (currentUserAccount === null || currentUserAccount === void 0 ? void 0 : (ref = currentUserAccount.roles) === null || ref === void 0 ? void 0 : ref.includes("HEYKANTINE_CONSUMER")) {
            menuList.push({
                href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/kantine/home"),
                label: t("common:navigation.heykantine")
            });
            return menuList;
        }
        menuList = [
            {
                href: (0,helpers/* buildFunnelUrl */.$e)({
                    router: router
                }),
                label: t("common:labels.requestCatering")
            },
            {
                href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/account/requests"),
                label: t("common:navigation.events")
            },
            {
                href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/account"),
                label: t("common:navigation.account")
            }, 
        ];
        if (currentUserAccount === null || currentUserAccount === void 0 ? void 0 : (ref1 = currentUserAccount.owner) === null || ref1 === void 0 ? void 0 : ref1.heykantineEnabled) {
            menuList.push({
                href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/account/kantine"),
                label: t("common:navigation.heykantine")
            });
        }
        return menuList;
    }();
    var topLinks = mainLinks || [
        {
            href: "",
            label: t("common:navigation.catering"),
            expandable: true,
            children: [
                {
                    href: "/",
                    label: t("common:navigation.individualOffer")
                },
                {
                    href: (0,urls/* marketplaceURL */.j5)("/catering"),
                    label: t("common:navigation.bookAProvider"),
                    outsideLink: true
                },
                {
                    href: "/branded-marketplace",
                    label: t("common:navigation.brandedMarketplace")
                }, 
            ]
        },
        {
            href: "/heykantine",
            label: t("common:navigation.onlineKantine")
        },
        {
            href: "/events",
            label: t("common:navigation.eventManagement")
        },
        {
            href: "",
            label: t("common:navigation.more"),
            expandable: true,
            children: [
                {
                    href: "/caterer",
                    label: t("common:navigation.forPartners")
                },
                {
                    href: "/blog",
                    label: t("common:navigation.hub")
                },
                {
                    href: "/sustainability",
                    label: t("common:navigation.sustainability")
                },
                {
                    href: "/about-us",
                    label: t("common:navigation.about")
                },
                {
                    href: "/press",
                    label: t("common:navigation.press")
                }, 
            ]
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavWrapper, {
        ref: navRef,
        className: "main-navigation",
        style: {
            minHeight: "inherit"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarEyebrow, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    as: "header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarEyebrowFlexWrapper, {
                        children: [
                            mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrustedShopsWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustedShopsStars/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Rating, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: (0,handleRatings/* formatRating */.A6)((0,handleRatings/* getRating */.h1)(ratings))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RatingText, {
                                                children: [
                                                    "\xa0",
                                                    t("trustedShops.ratingText")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingCount, {
                                        children: t("trustedShops.ratingCount", {
                                            amount: (0,handleRatings/* formatRatingCount */.mj)((0,handleRatings/* getRatingCount */.cz)(ratings))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TSLogoBox, {
                                        display: "flex",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustedShopsLogo/* default */.Z, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PhoneLink, {
                                href: constants/* CONTACT_PHONE.href */.Y.href,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: t("common:navigation.questions")
                                    }),
                                    constants/* CONTACT_PHONE.formatted */.Y.formatted
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLogo, {
                                    "aria-label": "Home",
                                    id: "navbar-logo",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menus, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuPrimary, {
                                        open: mobileMenuOpen,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList, {
                                                children: topLinks.map(function(link) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuListItem, {
                                                            "data-dropdown": !!link.children,
                                                            children: [
                                                                link.children ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuListItemLink, {
                                                                    as: "button",
                                                                    "aria-expanded": visibleDropdown === link.label,
                                                                    onClick: function() {
                                                                        return onToggleDropdownVisibility(link.label);
                                                                    },
                                                                    children: [
                                                                        link.label,
                                                                        visibleDropdown === link.label ? /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowUp/* default */.Z, {
                                                                            fontSize: "small"
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {
                                                                            fontSize: "small"
                                                                        })
                                                                    ]
                                                                }) : (link === null || link === void 0 ? void 0 : link.outsideLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledLink, {
                                                                    href: link.href,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuListItemLink, {
                                                                        children: [
                                                                            link.label,
                                                                            (link === null || link === void 0 ? void 0 : link.new) && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                                                                ml: 1,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_NewPill, {})
                                                                            })
                                                                        ]
                                                                    })
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: link.href,
                                                                    passHref: true,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuListItemLink, {
                                                                        children: [
                                                                            link.label,
                                                                            (link === null || link === void 0 ? void 0 : link.new) && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                                                                ml: 1,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_NewPill, {})
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                link.children && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownContent, {
                                                                    visible: visibleDropdown === link.label,
                                                                    "aria-expanded": visibleDropdown === link.label,
                                                                    className: "navigation-dropdown",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu, {
                                                                        children: link.children.map(function(child) {
                                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: child.href,
                                                                                passHref: true,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenuLink, {
                                                                                    children: [
                                                                                        child.label,
                                                                                        (child === null || child === void 0 ? void 0 : child.new) && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                                                                            ml: 1,
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_NewPill, {})
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }, child.href);
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, link.label);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuList, {
                                                children: [
                                                    showSignupButton && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListItemRight, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListItemLink, {
                                                            as: "button",
                                                            id: "open-login",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/account/login"),
                                                                children: t("common:navigation.signIn")
                                                            })
                                                        })
                                                    }),
                                                    isLoggedIn && !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuListItemRight, {
                                                        "data-dropdown": "true",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuListItemLink, {
                                                                as: "button",
                                                                "aria-expanded": visibleDropdown === "account",
                                                                onClick: function() {
                                                                    return onToggleDropdownVisibility("account");
                                                                },
                                                                children: [
                                                                    currentUserAccount.firstName,
                                                                    " ",
                                                                    currentUserAccount.lastName,
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        ml: 1,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {})
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownContent, {
                                                                visible: visibleDropdown === "account",
                                                                "aria-expanded": visibleDropdown === "account",
                                                                className: "navigation-dropdown",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownMenu, {
                                                                    children: [
                                                                        userMenuLinks.map(function(param) {
                                                                            var href = param.href, label = param.label;
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: href,
                                                                                passHref: true,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenuLink, {
                                                                                    children: label
                                                                                })
                                                                            }, href);
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenuLink, {
                                                                            onClick: logout,
                                                                            as: "button",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                children: t("common:navigation.signOut")
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListItemRight, {
                                                        wrapsButton: true,
                                                        children: typeof renderCTA === "function" ? renderCTA() : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: (0,helpers/* buildFunnelUrl */.$e)({
                                                                router: router
                                                            }),
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zx, {
                                                                rounded: true,
                                                                component: "a",
                                                                rel: "noopener",
                                                                id: "navbar-find-caterers",
                                                                children: t("common:labels.findCaterers")
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                        mdUp: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HamburgerButton, {
                                            "aria-label": mobileMenuOpen ? "Hide Navigation Menu" : "Show Navigation Menu",
                                            onClick: function() {
                                                return setMobileMenuOpen(!mobileMenuOpen);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuList, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListItemSecondary, {
                                                    children: mobileMenuOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon, {})
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var UnstyledLink = styled_components_browser_esm/* default.a */.ZP.a(Navigation_templateObject());
var NavWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1());
var NavbarEyebrow = styled_components_browser_esm/* default.section */.ZP.section(_templateObject2(), function(props) {
    return props.theme.palette.grey[800];
}, function(props) {
    return props.theme.zIndex.appBar + 1;
});
var PhoneLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject3());
var Navbar = styled_components_browser_esm/* default.header */.ZP.header(_templateObject4(), function(props) {
    return props.theme.navbar.height;
}, function(props) {
    return props.theme.zIndex.appBar;
}, function(props) {
    return props.theme.palette.grey[200];
});
var NavbarWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5());
var NavbarLogo = styled_components_browser_esm/* default.a */.ZP.a(_templateObject6(), function(props) {
    return props.theme.navbar.height;
});
var Menus = styled_components_browser_esm/* default.nav */.ZP.nav(_templateObject7());
var MenuPrimary = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject8(), function(props) {
    return props.theme.breakpoints.down("sm");
}, cssVariables/* cssVars.topBarHeight.name */.D.topBarHeight.name, function(props) {
    return props.theme.zIndex.appBar;
}, function(props) {
    return props.open ? "block" : "none";
});
var MenuList = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject9(), function(props) {
    return props.theme.breakpoints.down("sm");
});
var MenuListItem = styled_components_browser_esm/* default.li */.ZP.li(_templateObject10(), function(props) {
    return props.theme.navbar.height;
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.up("md");
});
var MenuListItemRight = (0,styled_components_browser_esm/* default */.ZP)(MenuListItem)(_templateObject11(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.wrapsButton ? "8px 8px 0" : "inherit";
}, function(props) {
    return props.wrapsButton ? 600 : 400;
}, function(props) {
    return props.wrapsButton ? "flex" : "inherit";
}, function(props) {
    return props.wrapsButton ? "center" : "initial";
});
var MenuListItemSecondary = (0,styled_components_browser_esm/* default */.ZP)(MenuListItem)(_templateObject12(), function(props) {
    return props.theme.navbar.height;
});
var MenuListItemLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject13(), function(props) {
    return props.theme.palette.text.primary;
}, function(props) {
    return props.theme.breakpoints.down("sm");
});
var DropdownContent = styled_components_browser_esm/* default.div */.ZP.div(_templateObject14(), function(props) {
    return props.theme.navbar.height;
}, function(props) {
    return props.theme.zIndex.appBar;
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.theme.palette.grey[50];
}, function(props) {
    return props.visible ? "block" : "none";
});
var DropdownMenu = styled_components_browser_esm/* default.div */.ZP.div(_templateObject15(), function(props) {
    return props.theme.spacing(0.5);
});
var DropdownMenuLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject16(), function(param) {
    var theme = param.theme;
    return theme.palette.text.primary;
}, function(param) {
    var theme = param.theme;
    return theme.palette.text.secondary;
}, function(props) {
    return props.theme.breakpoints.down("sm");
});
var HamburgerButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonBase/* default */.Z)(_templateObject17());
var NavbarEyebrowFlexWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject18(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("xs");
});
var TrustedShopsWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject19());
var Stars = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject20());
var RatingText = styled_components_browser_esm/* default.span */.ZP.span(_templateObject21(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("xs");
});
var RatingCount = styled_components_browser_esm/* default.span */.ZP.span(_templateObject22(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("md");
});
var Rating = styled_components_browser_esm/* default.span */.ZP.span(_templateObject23(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("xs");
});
var TSLogoBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject24());
/* harmony default export */ var layouts_Navigation = (Navigation);


/***/ }),

/***/ 45417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ createOpportunityCreationPayload; }
});

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/shared/helpers/analytics.js
var analytics = __webpack_require__(44955);
// EXTERNAL MODULE: ./src/shared/helpers/cities.js + 1 modules
var cities = __webpack_require__(6619);
;// CONCATENATED MODULE: ./src/qualification/services/webToLeadData.ts






var webToLeadData = function(param) {
    var caterer_minimum_order_value = param.caterer_minimum_order_value, _caterer_name = param.caterer_name, caterer_name = _caterer_name === void 0 ? "" : _caterer_name, catering_categories = param.catering_categories, city = param.city, comment = param.comment, company = param.company, conversion_url = param.conversion_url, degree_of_satiation = param.degree_of_satiation, _deliveryAddressStreetAndNumber = param.deliveryAddressStreetAndNumber, deliveryAddressStreetAndNumber = _deliveryAddressStreetAndNumber === void 0 ? "" : _deliveryAddressStreetAndNumber, _deliveryAddressCity = param.deliveryAddressCity, deliveryAddressCity = _deliveryAddressCity === void 0 ? "" : _deliveryAddressCity, _deliveryAddressPostalCode = param.deliveryAddressPostalCode, deliveryAddressPostalCode = _deliveryAddressPostalCode === void 0 ? "" : _deliveryAddressPostalCode, _deliveryAddressCountry = param.deliveryAddressCountry, deliveryAddressCountry = _deliveryAddressCountry === void 0 ? "" : _deliveryAddressCountry, drinks = param.drinks, email = param.email, equipment = param.equipment, event_date = param.event_date, first_name = param.first_name, isPredefinedOffer = param.isPredefinedOffer, last_name = param.last_name, lead_type = param.lead_type, min_order_number = param.min_order_number, number_of_vegans = param.number_of_vegans, number_of_vegetarians = param.number_of_vegetarians, number_of_carnivore = param.number_of_carnivore, phone = param.phone, price_per_person = param.price_per_person, _predefined_catering_offer_title = param.predefined_catering_offer_title, predefined_catering_offer_title = _predefined_catering_offer_title === void 0 ? "" : _predefined_catering_offer_title, service = param.service;
    var mappedCateringCategories = catering_categories.map(function(cateringCategory) {
        return platformToSalesforceCateringCategoryMapping[cateringCategory];
    });
    var mappedEventType = catering_categories.map(function(eventType) {
        return platformToSalesforceEventTypeMapping[eventType];
    });
    var eventDate = function() {
        if (!(event_date === null || event_date === void 0 ? void 0 : event_date.date)) return undefined;
        return format(new Date(event_date.date), "dd.MM.yyyy");
    }();
    var recurringNeed = function() {
        return (event_date === null || event_date === void 0 ? void 0 : event_date.recurring) === true;
    }();
    var privateLead = function() {
        return lead_type === "private";
    }();
    var _obj;
    return _obj = {}, _define_property(_obj, salesforceFieldMapping.oid, "00D58000000ZImI"), _define_property(_obj, salesforceFieldMapping.entrance_url, Cookies.get("entrance_url")), _define_property(_obj, salesforceFieldMapping.referrer_url, Cookies.get("referrer_url")), _define_property(_obj, salesforceFieldMapping.lead_source, "heycater.com Web2Lead form"), _define_property(_obj, salesforceFieldMapping.identity, getIdentity()), _define_property(_obj, salesforceFieldMapping.city, findCityNameByLocale(city, "de") || deliveryAddressCity), _define_property(_obj, salesforceFieldMapping.conversion_url, conversion_url), _define_property(_obj, salesforceFieldMapping.first_name, first_name), _define_property(_obj, salesforceFieldMapping.last_name, last_name), _define_property(_obj, salesforceFieldMapping.company, company), _define_property(_obj, salesforceFieldMapping.email, email), _define_property(_obj, salesforceFieldMapping.phone, phone), _define_property(_obj, salesforceFieldMapping.comment, "\n-- CUSTOMER COMMENT --\n".concat(comment !== null && comment !== void 0 ? comment : "", "\n").concat(predefined_catering_offer_title && "-- PREDEFINED OFFER---\n  Pre-defined offer selected: Menu: ".concat(predefined_catering_offer_title, "\n  Caterer: ").concat(caterer_name, "\n"))), _define_property(_obj, salesforceFieldMapping.catering_categories, mappedCateringCategories), _define_property(_obj, salesforceFieldMapping.deliveryAddressStreetAndNumber, deliveryAddressStreetAndNumber), _define_property(_obj, salesforceFieldMapping.deliveryAddressCity, deliveryAddressCity), _define_property(_obj, salesforceFieldMapping.deliveryAddressPostalCode, deliveryAddressPostalCode), _define_property(_obj, salesforceFieldMapping.deliveryAddressCountry, deliveryAddressCountry), _define_property(_obj, salesforceFieldMapping.event_type, mappedEventType), _define_property(_obj, salesforceFieldMapping.event_date, eventDate), _define_property(_obj, salesforceFieldMapping.pax, min_order_number), _define_property(_obj, salesforceFieldMapping.number_of_vegans, number_of_vegans), _define_property(_obj, salesforceFieldMapping.number_of_vegetarians, number_of_vegetarians), _define_property(_obj, salesforceFieldMapping.number_of_carnivore, number_of_carnivore), _define_property(_obj, salesforceFieldMapping.total_budget, caterer_minimum_order_value), _define_property(_obj, salesforceFieldMapping.price_per_person, price_per_person), _define_property(_obj, salesforceFieldMapping.recurring_need, recurringNeed), _define_property(_obj, salesforceFieldMapping.private_lead, privateLead), _define_property(_obj, salesforceFieldMapping.record_type, SALESFORCE_LEAD_RECORD_TYPES_MAPPING["Customer Lead"]), _define_property(_obj, salesforceFieldMapping.predefined_offer, predefined_catering_offer_title ? "1" : "0"), _define_property(_obj, salesforceFieldMapping.degree_of_satiation, degree_of_satiation), _define_property(_obj, salesforceFieldMapping.predefined_offer, isPredefinedOffer), _define_property(_obj, salesforceFieldMapping.equipment, equipment), _define_property(_obj, salesforceFieldMapping.drinks, drinks), _define_property(_obj, salesforceFieldMapping.service, service), _obj;
};
var salesforceFieldMapping = {
    catering_categories: "00N1i000002IQkd",
    city: "00N5800000CZO0T",
    company: "company",
    comment: "00N58000007Q0vz",
    conversion_url: "00N1i000002WWRT",
    degree_of_satiation: "Level_of_Satiation__c",
    deliveryAddressStreetAndNumber: "00N1i000000ldlY",
    deliveryAddressCity: "00N1i000000ldli",
    deliveryAddressPostalCode: "00N1i000002H93Y",
    deliveryAddressCountry: "00N1i000002HrsJ",
    drinks: "Drinks__c",
    email: "email",
    entrance_url: "00N1i000001A0eY",
    equipment: "Furnishing__c",
    event_type: "00N1i000002WRXM",
    event_date: "00N5800000E2R9g",
    first_name: "first_name",
    identity: "00N1i000002WT1c",
    last_name: "last_name",
    lead_language: "00N1i000002Nvv0",
    lead_source: "lead_source",
    number_of_vegans: "Anzahl_Vegan__c",
    number_of_vegetarians: "Anzahl_Vegetarisch__c",
    number_of_carnivore: "Anzahl_Fleisch__c",
    oid: "oid",
    pax: "00N58000005JWfk",
    price_per_person: "00N58000009Ikbm",
    phone: "phone",
    predefined_offer: "00N9Y000000OMsR",
    private_lead: "00N1i000002Ndz8",
    referrer_url: "00N1i000001A0eT",
    total_budget: "00N58000009IkXa",
    record_type: "recordType",
    recurring_need: "00N9Y000000NseP",
    service: "Staff__c"
};
var platformToSalesforceCateringCategoryMapping = {
    breakfast: "breakfast",
    business_lunch: "business-lunch",
    drinks: "drinks",
    christmas: "christmas",
    fingerfood: "fingerfood",
    cakes_and_sweets: "snacks-and-dessert",
    street_food: "street-food",
    event: "event",
    fine_dining: "fine-dining",
    buffet: "buffet",
    specials: "specials",
    home_office: "home-office",
    bbq: "bbq",
    easter: "easter",
    halloween: "halloween",
    summer_party: "summer-party",
    other: "other"
};
var platformToSalesforceEventTypeMapping = {
    summer_party: "Sommerfeier",
    christmas: "Weihnachtsfeier"
};

;// CONCATENATED MODULE: ./src/shared/services/opportunityCreationPayload.ts


var occasionToEventMapping = {
    meeting: "Meeting",
    team_event: "Firmenfeier / Event",
    company_event: "Firmenfeier / Event",
    summer_party: "Sommerfeier",
    christmas: "Weihnachtsfeier",
    conference: "Meeting",
    shooting: "Shooting / Dreh",
    other: "Sonstiges"
};
var CLOUD_GROUPS_SLUGS = {
    CATERING_CATEGORIES: "catering-categories"
};
var prepareGroupTagValues = function(groupSlug, selectedValues) {
    return selectedValues.map(function(value) {
        return {
            tagSlug: value,
            groupSlug: groupSlug
        };
    });
};
var cloudGroupTagValuesPayload = function(payload) {
    var catering_categories = payload.catering_categories;
    var selectedCateringCategories = catering_categories.filter(function(value) {
        return value !== "other";
    }).map(function(cateringCategory) {
        return platformToSalesforceCateringCategoryMapping[cateringCategory];
    });
    return prepareGroupTagValues(CLOUD_GROUPS_SLUGS.CATERING_CATEGORIES, selectedCateringCategories);
};
function createOpportunityCreationPayload(payload) {
    var _billingAddressStreetAndNumber = payload.billingAddressStreetAndNumber, billingAddressStreetAndNumber = _billingAddressStreetAndNumber === void 0 ? "" : _billingAddressStreetAndNumber, _billingAddressPostalCode = payload.billingAddressPostalCode, billingAddressPostalCode = _billingAddressPostalCode === void 0 ? "" : _billingAddressPostalCode, _billingAddressCity = payload.billingAddressCity, billingAddressCity = _billingAddressCity === void 0 ? "" : _billingAddressCity, customer_tier = payload.customer_tier, _billingCountry = payload.billingCountry, billingCountry = _billingCountry === void 0 ? "" : _billingCountry, catering_categories = payload.catering_categories, landingPageSource = payload.landingPageSource, caterer_minimum_order_value = payload.caterer_minimum_order_value, _caterer_name = payload.caterer_name, caterer_name = _caterer_name === void 0 ? "" : _caterer_name, inspiredByMenuId = payload.inspiredByMenuId, _conversion_url = payload.conversion_url, conversion_url = _conversion_url === void 0 ? "" : _conversion_url, occasion = payload.occasion, comment = payload.comment, degree_of_satiation = payload.degree_of_satiation, _deliveryAddressStreetAndNumber = payload.deliveryAddressStreetAndNumber, deliveryAddressStreetAndNumber = _deliveryAddressStreetAndNumber === void 0 ? "" : _deliveryAddressStreetAndNumber, _deliveryAddressPostalCode = payload.deliveryAddressPostalCode, deliveryAddressPostalCode = _deliveryAddressPostalCode === void 0 ? "" : _deliveryAddressPostalCode, _deliveryAddressCity = payload.deliveryAddressCity, deliveryAddressCity = _deliveryAddressCity === void 0 ? "" : _deliveryAddressCity, _deliveryCountry = payload.deliveryCountry, deliveryCountry = _deliveryCountry === void 0 ? "" : _deliveryCountry, _drinks = payload.drinks, drinks = _drinks === void 0 ? false : _drinks, event_date = payload.event_date, _equipment = payload.equipment, equipment = _equipment === void 0 ? false : _equipment, first_name = payload.first_name, _isPredefinedOffer = payload.isPredefinedOffer, isPredefinedOffer = _isPredefinedOffer === void 0 ? false : _isPredefinedOffer, last_name = payload.last_name, min_order_number = payload.min_order_number, number_of_vegetarians = payload.number_of_vegetarians, number_of_vegans = payload.number_of_vegans, number_of_carnivore = payload.number_of_carnivore, price_per_person = payload.price_per_person, catererSlug = payload.catererSlug, _predefined_catering_offer_title = payload.predefined_catering_offer_title, predefined_catering_offer_title = _predefined_catering_offer_title === void 0 ? "" : _predefined_catering_offer_title, _reorder_offer_id = payload.reorder_offer_id, reorder_offer_id = _reorder_offer_id === void 0 ? "" : _reorder_offer_id, _service = payload.service, service = _service === void 0 ? false : _service, _leadSource = payload.leadSource, leadSource = _leadSource === void 0 ? "" : _leadSource, is_multi_day = payload.is_multi_day, analyticsClientId = payload.analyticsClientId;
    return {
        analyticsClientId: analyticsClientId,
        cateringCategories: catering_categories.map(function(cateringCategory) {
            return cateringCategory === "other" ? undefined : platformToSalesforceCateringCategoryMapping[cateringCategory];
        }),
        occasion: occasion ? occasionToEventMapping[occasion] : undefined,
        overallBudget: caterer_minimum_order_value,
        budgetPerPerson: price_per_person,
        customerTier: customer_tier,
        numberOfPeople: min_order_number,
        vegetarianNumber: number_of_vegetarians,
        veganNumber: number_of_vegans,
        meatNumber: number_of_carnivore,
        catererSlug: catererSlug,
        isMultiday: is_multi_day,
        inspiredByMenuId: inspiredByMenuId,
        landingPageSource: landingPageSource,
        internalComment: "\n    ".concat(predefined_catering_offer_title && "-- PREDEFINED OFFER---\n      Pre-defined offer selected: Menu: ".concat(predefined_catering_offer_title, "\n      Caterer: ").concat(caterer_name, "\n    "), "\n    ").concat(reorder_offer_id && "-- RE-ORDER ---\n      Re-Order offer selected: ".concat(reorder_offer_id, "\n      Link: https://heycater.lightning.force.com/lightning/r/Catering_Offer__c/").concat(reorder_offer_id, "/view\n    ")),
        commentByHeycaterForCaterer: comment,
        predefinedOffers: isPredefinedOffer,
        contactPersonNote: "".concat(first_name, " ").concat(last_name),
        billingAddressStreetAndNumber: billingAddressStreetAndNumber,
        billingAddressPostalCode: billingAddressPostalCode,
        billingAddressCity: billingAddressCity,
        billingCountry: billingCountry,
        leadSource: leadSource,
        deliveryAddressStreetAndNumber: deliveryAddressStreetAndNumber,
        deliveryAddressPostalCode: deliveryAddressPostalCode,
        deliveryAddressCity: deliveryAddressCity,
        deliveryCountry: deliveryCountry,
        drinks: drinks,
        furniture: equipment,
        staff: service,
        locationCity: deliveryAddressCity,
        conversionUrl: conversion_url,
        entranceUrl: js_cookie_default().get("entrance_url"),
        referrerUrl: js_cookie_default().get("referrer_url"),
        degreeOfSatiation: degree_of_satiation,
        eventsAttributes: [
            {
                startsAt: event_date
            }, 
        ],
        cloudGroupTagValuesAttributes: cloudGroupTagValuesPayload(payload)
    };
}


/***/ }),

/***/ 95046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A6": function() { return /* binding */ formatRating; },
/* harmony export */   "cz": function() { return /* binding */ getRatingCount; },
/* harmony export */   "h1": function() { return /* binding */ getRating; },
/* harmony export */   "mj": function() { return /* binding */ formatRatingCount; }
/* harmony export */ });
var getRating = function(ratings) {
    return ratings["overall"].rating;
};
var getRatingCount = function(ratings) {
    return ratings["overall"].count;
};
var formatRating = function(rating) {
    return (Math.round(rating * 10) / 10).toFixed(1);
};
var formatRatingCount = function(ratingCount) {
    if (ratingCount < 10) {
        return ratingCount;
    }
    if (ratingCount < 100) {
        return 10 * Math.floor(ratingCount / 10) + "+";
    }
    return 100 * Math.floor(ratingCount / 100) + "+";
};


/***/ }),

/***/ 37582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function Logo(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1197 244.92",
        width: "150"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M512.39,180.42v-47c0-8.61-6.62-16-15.22-16.4-10.51-.47-17.94,7.63-17.94,17.83v45.56H454.72V36.25h24.51v69.2h.39c6.56-7.89,16.5-10.86,26.85-10.86,19.49,0,30.43,10.86,30.43,32.57v53.26Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M583.5,145.82c2,9.91,9.9,17.83,19.82,17.83s15.85-2,23.18-9.9l18.63,9.71c-10.1,14.06-22,19-41.81,19-27.75,0-45.58-18.82-45.58-44.58s17.83-44.6,45.58-44.6c26,0,44.59,19.83,44.59,42.61v9.92Zm20.36-31.72C592,114.1,586,122,584,130h39.64C621.69,122,615.74,114.1,603.86,114.1Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M696.22,217.9H670.41l19.86-47.64L658.5,96.8h26L702,140.05h.38l17.5-43.25h26Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M801.49,183.05c-27.75,0-45.58-18.82-45.58-44.58s17.84-44.6,45.58-44.6c15.86,0,25.76,5,34.67,14.88l-12.87,15.84c-5.94-5.94-10.9-9.91-21.8-9.91-11.69,0-19.82,9.91-19.82,23.79s8.92,23.77,19.82,23.77c9.91,0,15.86-4,21.8-11.89l15.86,15.86C827.25,178.1,817.35,183.05,801.49,183.05Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M918.94,180.42v-8.65h-.4c-6.56,8-16.53,10.95-28.49,10.95-19.93,0-37.87-16.93-37.87-44.83S870.12,93,890.05,93c12,0,21.93,3,28.49,11h.4V96.8h24.51v83.62Zm-21.11-63.75c-9.91,0-19.81,7.92-19.81,21.8s9.9,21.8,19.81,21.8c11.89,0,20.81-7.93,20.81-21.8S909.72,116.67,897.83,116.67Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1000.5,183.11c-13.93,0-23.89-7-23.89-24.88v-39.8H962.89l3-21.63h10.77V69.28l24.51-3.93V96.8h17.3v21.63h-17.3v31.44c0,9.84,9.17,11.79,17.3,3.94v22.33C1014.44,180.12,1006.68,183.11,1000.5,183.11Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1063.59,145.82c2,9.91,9.91,17.83,19.82,17.83s15.86-2,23.19-9.9l18.62,9.71c-10.11,14.06-22,19-41.81,19-27.75,0-45.59-18.82-45.59-44.58s17.84-44.6,45.59-44.6c25.95,0,44.58,19.83,44.58,42.61v9.92Zm20-31.72c-11.89,0-17.83,7.94-19.82,15.86h39.64C1101.41,122,1095.47,114.1,1083.58,114.1Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1168.36,136.15v44.27h-24.51V96.8h24.51v10.09h.4c6.7-10.09,12.79-13.12,27-13.12V117C1177.48,115,1168.36,123,1168.36,136.15Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1213.05,140.05V37.69h26V140.05Zm0,40.37V153h26v27.39Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "cls-1",
                d: "M137.12,236.78",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M217.92,38.07S224,25,244.68,24.74L244.3,7.06S216,6,202.38,29.36Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M175.26,173.1c1.11-36.37-28.88-48.59-28.88-48.59,24-43.6,24-89.54,24-89.54-1.93-41.8-42.15-35-42.15-35l1.86,17.48c24.79-3.32,22.77,19.26,22.77,19.26,2.76,27.39-24.07,84.22-24.07,84.22-34.8,0-55.72,35.91-55.72,35.91C55,190.13,60.87,214.2,76,213.27s29.8-20.73,29.8-20.73c14.26-16.29,32.95-51.65,32.95-51.65,19.07,7.59,19.25,32.59,19.25,32.59-1.95,39.54-27.39,57.94-27.39,57.94l11.84,13C178.4,212.16,175.26,173.1,175.26,173.1ZM79.18,194s5.51-44.62,39.41-53.14C118.59,140.89,91.41,188.64,79.18,194Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M42,87.14s21.63,6.74,32.59,15.25L85.32,88.32S65.7,73.7,44.6,69.81Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M306.47,120.9C305.56,96.83,273,97.38,273,97.38c-23.13.93-33.77,7.41-33.77,7.41-9.35-16.47,6.75-37,6.75-37L232.44,56.29C208.37,86.08,223.55,115,223.55,115c-31.1,26.08-32.94,56.09-15,83.67S263,227.3,263,227.3l.19-17.38c-27.21-1.84-48.12-23-48.3-45S235,128.65,235,128.65c16.29,12.77,40,14.26,40,14.26C310,143.11,306.47,120.9,306.47,120.9Zm-18.84,2.42c-2.79,3-28.69,1.3-35-4.63,0,0,20-8.32,35,0,0,0,2.77,1.67,0,4.63Z",
                transform: "translate(-42 0.47)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M316.17,190.18s4.17-9.57,20.41-21.52l-10.2-14.58s-18.95,13.47-26.3,27.63Z",
                transform: "translate(-42 0.47)"
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Logo);


/***/ }),

/***/ 36902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TrustedShopsLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





function TrustedShopsLogo(_param) {
    var _fill = _param.fill, fill = _fill === void 0 ? "#fff" : _fill, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "fill"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 32 32",
        fill: fill
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            id: "etrusted-logo",
            d: "M5.785,15.972A10.082,10.082,0,1,0,15.868,5.891,10.082,10.082,0,0,0,5.785,15.972ZM0,16.023a16,16,0,1,1,16,16A16,16,0,0,1,0,16.023Zm18.025-5.972a1.175,1.175,0,0,1,1.18,1.308c0,2.519-2.965,4.271-5.1,4.909.446-1.753,1.626-6.216,3.921-6.216Zm-3.538,13.2c2.74,0,4.781-1.977,6.248-4.144l-.8-.606c-1.052,1.275-2.485,3-4.271,3A2.127,2.127,0,0,1,13.626,19.1a11.714,11.714,0,0,1,.191-1.817l.445-.112c2.889-.719,7.97-1.984,7.97-5.4C22.232,9.766,20,9.1,18.343,9.1,13.4,9.1,9.9,13.75,9.9,18.5c0,2.932,1.689,4.749,4.59,4.749Z",
            transform: "translate(0 -0.024)"
        })
    }));
}


/***/ }),

/***/ 95359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TrustedShopsStars; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function TrustedShopsStars() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 111.181 18.982",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "ic-review_rating",
            transform: "translate(10824 20794)",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "star-filled",
                    d: "M9.489,0,7.249,7.248,0,7.251l5.865,4.48L3.627,18.982,9.488,14.5l5.868,4.48-2.239-7.251,5.865-4.48-7.249,0Z",
                    transform: "translate(-10731.801 -20794)",
                    fill: "#ffdc0f",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "star-filled-2",
                    "data-name": "star-filled",
                    d: "M9.489,0,7.249,7.248,0,7.251l5.865,4.48L3.627,18.982,9.488,14.5l5.868,4.48-2.239-7.251,5.865-4.48-7.249,0Z",
                    transform: "translate(-10777.9 -20794)",
                    fill: "#ffdc0f",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "star-filled-3",
                    "data-name": "star-filled",
                    d: "M9.489,0,7.249,7.248,0,7.251l5.865,4.48L3.627,18.982,9.488,14.5l5.868,4.48-2.239-7.251,5.865-4.48-7.249,0Z",
                    transform: "translate(-10754.851 -20794)",
                    fill: "#ffdc0f",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "star-filled-4",
                    "data-name": "star-filled",
                    d: "M9.489,0,7.249,7.248,0,7.251l5.865,4.48L3.627,18.982,9.488,14.5l5.868,4.48-2.239-7.251,5.865-4.48-7.249,0Z",
                    transform: "translate(-10800.95 -20794)",
                    fill: "#ffdc0f",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "star-filled-5",
                    "data-name": "star-filled",
                    d: "M9.489,0,7.249,7.248,0,7.251l5.865,4.48L3.627,18.982,9.488,14.5l5.868,4.48-2.239-7.251,5.865-4.48-7.249,0Z",
                    transform: "translate(-10824 -20794)",
                    fill: "#ffdc0f",
                    fillRule: "evenodd"
                })
            ]
        })
    });
}


/***/ }),

/***/ 10904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ buildFunnelUrl; },
/* harmony export */   "H": function() { return /* binding */ buildAddress; },
/* harmony export */   "bB": function() { return /* binding */ buildFaqMarkup; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; }
/* harmony export */ });
/* unused harmony export parsedQueryParams */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32924);
/* harmony import */ var lodash_toPairs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93220);
/* harmony import */ var lodash_toPairs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_toPairs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var qualification_schema_questions_cateringCategoriesQuestion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61535);
/* harmony import */ var qualification_schema_questions_cityQuestion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26407);







var buildFaqMarkup = function(faqs) {
    return {
        "@context": "https://schema.org/",
        "@type": "FAQPage",
        mainEntity: faqs.map(function(faq) {
            return {
                "@type": "Question",
                name: faq.fields.question,
                acceptedAnswer: {
                    "@type": "Answer",
                    text: (0,_contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToPlainTextString */ .a)(faq.fields.answer)
                }
            };
        })
    };
};
var buildFunnelUrl = function(param) {
    var city = param.city, cateringCategories = param.cateringCategories, selectedCatererId = param.selectedCatererId, router = param.router;
    var parsedParameters = {};
    if (city) {
        parsedParameters.city = (0,qualification_schema_questions_cityQuestion__WEBPACK_IMPORTED_MODULE_4__/* .isValidCity */ .m0)(city.toLowerCase()) ? city.toLowerCase() : "other";
    }
    if (selectedCatererId) {
        parsedParameters.selectedCatererId = selectedCatererId;
    }
    if (Array.isArray(cateringCategories)) {
        var validCateringCategories = cateringCategories.filter(qualification_schema_questions_cateringCategoriesQuestion__WEBPACK_IMPORTED_MODULE_3__/* .isValidCateringCategory */ .kl);
        if (validCateringCategories.length) {
            parsedParameters.catering_categories = validCateringCategories;
        } else {
            parsedParameters.catering_categories = [
                "other"
            ];
        }
    }
    return "/start".concat((0,qs__WEBPACK_IMPORTED_MODULE_2__.stringify)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, parsedParameters), {
        leadSource: "".concat("https://www.heycater.com").concat(router.asPath.split("?")[0])
    }), {
        addQueryPrefix: true
    }));
};
var parsedQueryParams = function() {
    if (false) {}
    return parse(window.location.search, {
        ignoreQueryPrefix: true
    });
};
var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
    if (!string) {
        return "";
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
};
var buildAddress = function(addressComponents) {
    return lodash_toPairs__WEBPACK_IMPORTED_MODULE_1___default()(addressComponents).map(function(component) {
        if (!component[1]) return "";
        switch(component[0]){
            case "street":
                return "".concat(component[1], ", ");
            case "postalCode":
                return "".concat(component[1], " ");
            case "city":
                return component[1];
            case "country":
                return ", ".concat(component[1]);
            default:
                return component[1];
        }
    }).join("");
};


/***/ }),

/***/ 10758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95197);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85444);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  --padding: ",
        "px;\n\n  --contentMaxWidth: ",
        "px;\n\n  --maxWidthIncludingPadding: calc(\n    var(--contentMaxWidth) + (2 * var(--padding))\n  );\n\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: var(--padding);\n  padding-right: var(--padding);\n\n  width: clamp(100px, 100%, var(--maxWidthIncludingPadding));\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var sizes = {
    xs: 690,
    xsm: 860,
    sm: 930,
    md: 1250,
    lg: 1890
};
var StyledContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu)(_templateObject(), function(param) {
    var theme = param.theme, disableGutters = param.disableGutters, padding = param.padding;
    return disableGutters ? 0 : theme.spacing(padding !== null && padding !== void 0 ? padding : 2);
}, function(param) {
    var size = param.size;
    return typeof size === "number" ? size : sizes[size || "md"];
});
var Container = StyledContainer;
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ })

}]);